import { capitalizeString } from 'src/utils';

type WithType = { type: string };
export const mapNewItem = <T extends WithType>(data: T) => {
  if (data.type === 'folder') {
    return {
      loaded: true,
      children: [],
      creation_date: new Date().getTime() / 1000,
      ...data,
    };
  }

  return data;
};

export const getRootFolder = (label: string) => ({
  id: 0,
  label: label || 'my',
  type: 'folder',
});

type WithIdAndLabelType = {
  id: string;
  label: string;
  pic: string;
  source: string;
};
export const mapDemographicItem = (
  demographic: WithIdAndLabelType,
  demographicClass: string
) => ({
  id: demographic.id,
  label: demographic.label,
  pic: demographic.pic,
  type: 'demographic',
  class: demographicClass,
  source: demographic.source,
  taxonomy: [`Demographic > ${capitalizeString(demographicClass)}`],
});
